const columns = () => {
  return [
    {
      title: "角色名称",
      name: "name",
      dataIndex: "name",
      searchItem: {},
      tableItem: {
        width: 200
      }
    },
    {
      title: "角色编码",
      name: "code",
      dataIndex: "code",
      searchItem: {},
      tableItem: {
        width: 200
      }
    },
    {
      title: "角色描述",
      name: "remark",
      dataIndex: "remark",
      tableItem: {
        width:300,
      }
    }
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'role/getListByPage',
    ...api
  }
}

const roleInfo = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    columns: columns(),
    cols: {
      xs: 12,
      md: 12,
      xl: 12
    },
    tableApi: tableApi(api)
  }
}

export default roleInfo
